import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import {catchError} from 'rxjs/operators';

@Injectable()
export class MarketingCopyDetailsService extends BaseHttpService {

  private rootUrl: string = 'items/market-copy-details';

  fetchMarketingCopy(brandId: string, itemId: number): Observable<any> {
    return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}/${itemId}`)

        .pipe(catchError(this.handleError.bind(this)));
  }
}
